<div class="card" id="currentNotifications">
  <div class="card-header">
    <h5 class="card-title">NOTIFICATIONS</h5>
  </div>
  <div class="card-body">
    <ngx-datatable
      id="currentNotificationsTable"
      class="material striped scroll-vertical detail-hover"
      [rows]="notifications"
      [sorts]="[{ prop: 'startTime', dir: 'desc' }]"
      [loadingIndicator]="isDataLoading"
      [columnMode]="tableConfig.columnMode"
      [headerHeight]="tableConfig.headerHeight"
      [footerHeight]="tableConfig.footerHeight"
      [rowHeight]="tableConfig.rowHeight"
      [reorderable]="tableConfig.allowColumnReordering"
      [limit]="tableConfig.limit"
      [rowClass]="notificationRowClass"
      [virtualization]="tableConfig.virtualization"
      #table
    >
      <ngx-datatable-row-detail [rowHeight]="tableConfig.rowHeight">
        <ng-template let-row="row" ngx-datatable-row-detail-template>
          <th-follow-up-datatable [followUpRows]="row.followUps"></th-follow-up-datatable>
        </ng-template>
      </ngx-datatable-row-detail>

      <ngx-datatable-column
        [width]="50"
        [resizeable]="false"
        [sortable]="false"
        [draggable]="false"
        [canAutoResize]="false"
      >
        <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
          <a
            *ngIf="row.followUps?.length > 0"
            href="javascript:"
            [class.datatable-icon-right]="!expanded"
            [class.datatable-icon-down]="expanded"
            class="expand-collapse"
            title="Expand/Collapse Thread"
            (click)="table.rowDetail.toggleExpandRow(row)"
          >
          </a>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Notification" prop="message">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ng-container *ngIf="row.message">
            <h5 class="fw-bold color-black">{{ row.subject }}</h5>
            <div class="ckeditor-text" [innerHTML]="row.message"></div>
          </ng-container>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Date" prop="startTime">
        <ng-template let-row="row" ngx-datatable-cell-template>{{ row.startTime | date: dateFormat }}</ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
</div>
